<template>
  <div>
    <div class="columns row-table-headings">
      <div class="column column-no">{{ index + 1 }}.</div>
      <div class="column column-criteria-title">
        <div :class="$style.criteriaTitleContainer">
          {{ criteriaOption.criteria.title }}
        </div>
        <b-collapse
          v-if="criteriaOption.criteria.guide !== ''"
          :open="false"
          aria-id="contentIdForA11y1"
        >
          <template #trigger="props">
            <div class="guide-btn-container">
              <b-button
                :label="!props.open ? 'Show Guide' : 'Hide Guide'"
                class="guide-trigger-btn"
                aria-controls="contentIdForA11y1"
              />
              <b-icon
                :icon="!props.open ? 'chevron-down' : 'chevron-up'"
                size="is-medium"
              >
              </b-icon>
            </div>
          </template>
          <div :class="$style.guideSection">
            <div class="content">
              {{ criteriaOption.criteria.guide }}
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <!-- Free Input Type -->
    <div v-if="!isRange">
      <!-- Aggergate Mode -->
      <div v-if="mode === 'aggregate'" class="columns row-table-content">
        <div class="column column-empty"></div>
        <div class="column column-table-data">
          <div :class="[$style.valueContainer]">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th :class="$style.answerChoicesHeader">Answer</th>
                  <th :class="$style.totalToDateHeader">
                    Total To-Date
                    <b-tooltip
                      v-if="totalToDateMessage"
                      label="Includes the value currently being edited"
                      position="is-bottom"
                      :class="$style.infoTooltip"
                    >
                      <b-icon
                        icon="information-outline"
                        size="is-small"
                        custom-size="mdi-15px"
                        :custom-class="$style.infoIcon"
                      >
                      </b-icon>
                    </b-tooltip>
                  </th>
                  <th :class="$style.countHeader">Count</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td colspan="3" style="padding: 0px">
                    <div
                      :class="[
                        options.length > 8
                          ? $style.scrollableColumn
                          : $style.nonScrollableColumn,
                      ]"
                    >
                      <table class="table is-fullwidth">
                        <tbody>
                          <tr
                            v-for="(optionsData, optionsDataIndex) in options"
                            :key="optionsDataIndex"
                          >
                            <td
                              v-if="options[optionsDataIndex].option === 'N/A'"
                              :class="$style.answerChoicesColumn"
                            >
                              <b-field>
                                <b-input
                                  type="text"
                                  placeholder="N/A"
                                  v-model="options[optionsDataIndex].option"
                                  disabled
                                >
                                </b-input>
                              </b-field>
                            </td>
                            <td v-else :class="$style.answerChoicesColumn">
                              <b-field>
                                <b-input
                                  v-model="options[optionsDataIndex].option"
                                  type="text"
                                  @input="
                                    validateOptionsDataInput(optionsDataIndex)
                                  "
                                ></b-input>
                              </b-field>
                              <p
                                v-if="
                                  validateOptionsDataInputError(
                                    optionsDataIndex,
                                  )
                                "
                                :class="$style.validationCountErrorMessage"
                              >
                                {{
                                  validateOptionsDataInputError(
                                    optionsDataIndex,
                                  )
                                }}
                              </p>
                            </td>
                            <td :class="$style.totalToDateColumn">
                              {{ optionsData.totalToDate }}
                            </td>

                            <td
                              :class="[
                                $style.paddingBottom15,
                                $style.countColumnContainer,
                              ]"
                            >
                              <div
                                class="columns"
                                :class="$style.countBottomDivStyle"
                              >
                                <b-field>
                                  <b-input
                                    type="number"
                                    v-model="options[optionsDataIndex].value"
                                    onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                                    :class="
                                      options[optionsDataIndex].option === 'N/A'
                                        ? [
                                            $style.naValueColumn,
                                            $style.numberInput,
                                          ]
                                        : $style.numberInput
                                    "
                                    @input="
                                      validateOptionsDataValue(optionsDataIndex)
                                    "
                                  >
                                  </b-input>
                                </b-field>
                                <div
                                  v-if="
                                    options[optionsDataIndex].option !== 'N/A'
                                  "
                                  :class="$style.plusIconColumn"
                                >
                                  <a
                                    @click="
                                      handleRemoveOption(
                                        options[optionsDataIndex],
                                        optionsDataIndex,
                                      )
                                    "
                                  >
                                    <b-icon icon="close" size="is-small">
                                    </b-icon>
                                  </a>
                                </div>
                              </div>
                              <p
                                v-if="options[optionsDataIndex].value === ''"
                                :class="$style.validationCountErrorMessage"
                              >
                                Value must not be empty
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td :class="$style.answerChoicesColumn">
                    <b-field>
                      <b-input
                        type="text"
                        v-model="optionInput"
                        @input="validateInput(optionInput)"
                      ></b-input>
                    </b-field>
                    <p
                      v-if="invalidOptionInputErrorMessage.length"
                      :class="$style.validationCountErrorMessage"
                    >
                      {{ invalidOptionInputErrorMessage }}
                    </p>
                  </td>
                  <td :class="$style.totalToDateColumn">
                    {{ totalToDateValue }}
                  </td>
                  <td
                    :class="[
                      $style.countBottomStyle,
                      $style.footerCountContainer,
                    ]"
                  >
                    <div class="columns" :class="$style.countBottomDivStyle">
                      <b-field>
                        <b-input
                          :class="$style.numberInput"
                          type="number"
                          onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                          v-model="optionCount"
                        ></b-input>
                      </b-field>
                      <div :class="$style.plusIconColumn">
                        <img
                          v-if="
                            optionInput === '' ||
                            optionCount === '' ||
                            showOptionCountError
                          "
                          src="~@/assets/icons/add_circle-disabled.png"
                          :class="$style.disableOptionPlusIcon"
                        />
                        <a v-else @click="handleAddCountValue()">
                          <img
                            src="~@/assets/icons/ic_submitrecord.png"
                            :class="$style.plusIcon"
                          />
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <!-- Individual Mode -->
      <div v-else class="columns row-table-content">
        <div class="column column-empty"></div>
        <div class="column column-table-data">
          <div :class="[$style.valueContainer]">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th :class="$style.answerChoicesHeader">Answer</th>
                  <th :class="$style.totalToDateHeader">
                    Total To-Date
                    <b-tooltip
                      v-if="totalToDateMessage"
                      label="Includes the value currently being edited"
                      position="is-bottom"
                      :class="$style.infoTooltip"
                    >
                      <b-icon
                        icon="information-outline"
                        size="is-small"
                        custom-size="mdi-15px"
                        :custom-class="$style.infoIcon"
                      >
                      </b-icon>
                    </b-tooltip>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td :class="$style.answerChoicesColumn">
                    <b-field>
                      <b-input
                        @input="handleIndividualInputOption"
                        v-model="optionInputIndividual"
                        type="text"
                        :disabled="setForNaOptionIndividualMode"
                      ></b-input>
                    </b-field>
                    <p
                      v-if="invalidIndividualInputErrorMessage.length"
                      :class="$style.validationCountErrorMessage"
                    >
                      {{ invalidIndividualInputErrorMessage }}
                    </p>
                  </td>
                  <td :class="$style.totalToDateColumn">
                    {{ totalToDateValue }}
                  </td>
                </tr>
                <tr>
                  <td :class="$style.answerChoicesColumn">
                    <input
                      type="checkbox"
                      value="true"
                      v-model="setForNaOptionIndividualMode"
                    />
                    <span :class="$style.submitForNACheckboxSpan"
                      >Submit for N/A</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Range type -->
    <div v-else>
      <!-- Aggergate Mode -->
      <div v-if="mode === 'aggregate'" class="columns row-table-content">
        <div class="column column-empty"></div>
        <div class="column column-table-data">
          <div :class="[$style.valueContainer]">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th :class="$style.answerChoicesHeaderStyle">
                    Answer Choices
                  </th>
                  <th :class="$style.answerHeaderStyle">Answer</th>
                  <th :class="$style.answerTotalHeaderStyle">
                    Total To-Date
                    <b-tooltip
                      v-if="totalToDateMessage"
                      label="Includes the value currently being edited"
                      position="is-bottom"
                      :class="$style.infoTooltip"
                    >
                      <b-icon
                        icon="information-outline"
                        size="is-small"
                        custom-size="mdi-15px"
                        :custom-class="$style.infoIcon"
                      >
                      </b-icon>
                    </b-tooltip>
                  </th>
                  <th :class="$style.countHeaderStyle">Count</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td :class="$style.sliderBodyStyle">
                    <section>
                      <b-field>
                        <b-input
                          v-model="sliderValue"
                          type="text"
                          :class="$style.numberInput"
                        ></b-input>
                        <span :class="$style.rangeValue"
                          ><span :class="$style.bold">Min:</span>
                          {{ minValue }},
                          <span :class="$style.bold">Max:</span>
                          {{ maxValue }}</span
                        >
                      </b-field>
                      <p
                        v-if="showRangeErrorMessage"
                        :class="$style.validationCountErrorMessage"
                      >
                        {{
                          invalidSliderErrorMessage.length
                            ? invalidSliderErrorMessage
                            : `Value must be between ${minValue} to ${maxValue}`
                        }}
                      </p>
                      <br />
                      <br />
                      <b-field style="padding: 0px 13px">
                        <Slider
                          v-if="sliderValue === ''"
                          v-model="sliderValue"
                          :max="maxValue"
                          :min="minValue"
                          :step="-1"
                          :format="formatSliderTooltip"
                          :options="{
                            start: [minValue],
                          }"
                        />
                        <Slider
                          v-else
                          v-model="sliderValue"
                          :max="maxValue"
                          :min="minValue"
                          :step="-1"
                          :format="formatSliderTooltip"
                          :tooltips="disableTooltipSlider"
                        />
                      </b-field>
                    </section>
                  </td>
                  <td colspan="3" :class="$style.answerBodyStyle">
                    <div
                      :class="[
                        answerValueDetail.length > 8
                          ? $style.rangeScrollableColumn
                          : answerValueDetail.length > 1
                          ? $style.rangeNonScrollableColumn
                          : $style.singleNAColumn,
                        $style.answerValueContainer,
                      ]"
                    >
                      <table
                        class="table is-fullwidth"
                        :class="$style.rangeTable"
                      >
                        <tbody>
                          <tr
                            v-for="(item, itemIndex) in answerValueDetail"
                            :key="itemIndex"
                          >
                            <td :class="$style.answerTotalTableStyle">
                              {{ item.option }}
                            </td>
                            <td :class="$style.answerTotalTableStyle">
                              {{ item.totalToDate }}
                            </td>
                            <td :class="$style.countTableStyle">
                              <div
                                class="columns"
                                :class="$style.countTableDivStyle"
                              >
                                <b-field>
                                  <b-input
                                    :class="$style.numberInput"
                                    type="number"
                                    v-model="item.value"
                                    onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                                    @input="updateRangeValue(item, itemIndex)"
                                    maxlength="7"
                                    min="0"
                                  ></b-input>
                                </b-field>
                                <div :class="$style.plusIconColumn">
                                  <a
                                    @click="
                                      handleRemoveRangeValue(item, itemIndex)
                                    "
                                  >
                                    <b-icon
                                      v-if="
                                        itemIndex !==
                                        answerValueDetail.length - 1
                                      "
                                      type="is-black"
                                      icon="close"
                                      size="is-small"
                                    ></b-icon>
                                  </a>
                                </div>
                              </div>
                              <div
                                v-for="(val, index) in validateValueError"
                                :key="index"
                              >
                                <p
                                  v-if="
                                    val.option === item.option && val.hasError
                                  "
                                  :class="$style.validationErrorMessage"
                                >
                                  Value must not be empty
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td :class="$style.answerChoicesBottomStyle"></td>
                  <td :class="$style.answerTotalBottomStyle">
                    {{ sliderValue }}
                  </td>
                  <td :class="$style.answerTotalBottomStyle">
                    {{ totalToDateRangeValue }}
                  </td>
                  <td :class="$style.countBottomStyle">
                    <div class="columns" :class="$style.countBottomDivStyle">
                      <b-field>
                        <b-input
                          :class="$style.numberInput"
                          type="number"
                          v-model="countValue"
                          onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          maxlength="7"
                          min="0"
                        ></b-input>
                      </b-field>
                      <div :class="$style.plusIconColumn">
                        <img
                          v-if="
                            sliderValue === '' ||
                            showCountErrorMessage ||
                            showRangeErrorMessage
                          "
                          src="~@/assets/icons/add_circle-disabled.png"
                          :class="$style.disablePlusIcon"
                        />
                        <a v-else @click="handleAddCountValueRange(countValue)">
                          <img
                            src="~@/assets/icons/ic_submitrecord.png"
                            :class="$style.plusIconRange"
                          />
                        </a>
                      </div>
                    </div>
                    <p
                      v-if="showCountErrorMessage"
                      :class="$style.validationCountErrorMessage"
                    >
                      Value must not be empty
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- Individual Mode -->
      <div v-else class="columns row-table-content">
        <div class="column column-empty"></div>
        <div class="column column-table-data">
          <div :class="[$style.valueContainer]">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th :class="$style.answerChoicesHeaderStyle">
                    Answer Choices
                  </th>
                  <th :class="$style.answerHeaderStyle">Answer</th>
                  <th :class="$style.totalHeaderStyle">
                    Total To-Date
                    <b-tooltip
                      v-if="totalToDateMessage"
                      label="Includes the value currently being edited"
                      position="is-bottom"
                      :class="$style.infoTooltip"
                    >
                      <b-icon
                        icon="information-outline"
                        size="is-small"
                        custom-size="mdi-15px"
                        :custom-class="$style.infoIcon"
                      >
                      </b-icon>
                    </b-tooltip>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td :class="$style.answerChoicesBodyStyle">
                    <section>
                      <b-field>
                        <b-input
                          v-if="hasSelectedNA"
                          type="text"
                          :controls="false"
                          :class="$style.disableNumberInput"
                          disabled
                        ></b-input>
                        <b-input
                          v-else
                          v-model="sliderValue"
                          type="text"
                          :class="$style.numberInput"
                        ></b-input>
                        <span :class="$style.rangeValue"
                          ><span :class="$style.bold">Min:</span>
                          {{ minValue }},
                          <span :class="$style.bold">Max:</span>
                          {{ maxValue }}</span
                        >
                      </b-field>
                      <p
                        v-if="showRangeErrorMessage"
                        :class="$style.validationCountErrorMessage"
                      >
                        {{
                          invalidSliderErrorMessage.length
                            ? invalidSliderErrorMessage
                            : `Value must be between ${minValue} to ${maxValue}`
                        }}
                      </p>
                      <div :class="$style.submitAsNAContainer">
                        <a v-if="hasSelectedNA" @click="handleMarkedNAValue()">
                          <b-icon
                            icon="radiobox-marked"
                            size="is-small"
                            :custom-class="$style.iconsColorMarked"
                            custom-size="mdi-24px"
                          >
                          </b-icon>
                        </a>
                        <a v-else @click="handleUnmarkedNAValue()">
                          <b-icon
                            icon="radiobox-blank"
                            size="is-small"
                            :custom-class="$style.iconsColorUnmarked"
                            custom-size="mdi-24px"
                          >
                          </b-icon>
                        </a>
                        <div style="padding-left: 10px">
                          Submit answer as N/A
                        </div>
                      </div>

                      <br />
                      <br />
                      <br />
                      <b-field style="padding: 0px 13px">
                        <Slider
                          v-if="sliderValue === ''"
                          v-model="sliderValue"
                          :max="maxValue"
                          :min="minValue"
                          :step="-1"
                          :format="formatSliderTooltip"
                          :options="{
                            start: [minValue],
                          }"
                        />
                        <Slider
                          v-else
                          v-model="sliderValue"
                          :max="maxValue"
                          :min="minValue"
                          :step="-1"
                          :format="formatSliderTooltip"
                          :tooltips="disableTooltipSlider"
                        />
                      </b-field>
                    </section>
                  </td>
                  <td :class="$style.answerBodyStyleRange">
                    <span v-if="hasSelectedNA">N/A</span>
                    <span v-else>{{ sliderValue }}</span>
                  </td>
                  <td :class="$style.totalBodyStyle">
                    {{ totalToDateRangeValue }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="columns row-table-comment"
      v-if="
        !criteriaOption.isCommentSectionExpanded &&
        resultData.criteriaData.length > 1
      "
    >
      <div class="column column-empty-comment"></div>
      <div
        class="column column-data-comment"
        @click="showCommentBox(criteriaOption)"
      >
        + Add Comment
      </div>
    </div>
    <div
      class="columns row-table-comment"
      v-if="
        criteriaOption.isCommentSectionExpanded ||
        resultData.criteriaData.length === 1
      "
    >
      <div class="column column-empty-comment"></div>
      <div class="column column-data-comment-box">
        <b-field label="Comment">
          <b-input v-model="criteriaOption.comments" type="textarea"> </b-input>
        </b-field>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep, cloneDeep as _cloneDeep } from 'lodash';
import Slider from '@vueform/slider/dist/slider.vue2.js';
import { isDifferent } from '@/jbi-shared/util/watcher.vue-decorator';
import {
  DataCollectionCriteriaDataPayload,
  RangeOptionValueType,
  RangeErrorValidation,
} from '@/store/modules/audits/types/audits.types';

@Component({
  components: {
    Slider,
  },
})
export default class DataCollectionContinuousDiscreteCriteria extends Vue {
  @Prop()
  public index!: number;

  @Prop()
  public criteriaOption!: any;

  @Prop()
  public resultData!: any;

  @Prop()
  public totalToDateMessage!: boolean;

  @Prop()
  public editDataCollectionRecord!: any;

  @Prop()
  public criteriaSamplingData!: any;

  @Prop()
  public mode!: string;

  @Prop()
  public tryToSubmitKey!: number;

  public optionInput: string | number = '';
  public optionTotalToDate: number = 0;
  public optionCount: number = 0;
  public options: any[] = [];
  public isRange: boolean = false;
  public optionInputIndividual: string | number = '';
  public optionCountIndividual: number = 1;
  public setForNaOptionIndividualMode: boolean = false;
  public sliderValue: string | number = '';
  public tempSliderValue: number | string = '';
  public showRangeErrorMessage: boolean = false;
  public answerValueDetail: any[] = [];
  public existingOptions: any[] = [];
  public showValueErrorMessage: boolean = false;
  public countValue: number = 0;
  public showCountErrorMessage: boolean = false;
  public hasSelectedNA: boolean = false;
  public validateValueError: RangeErrorValidation[] = [];
  public removedAnswerValueDetail: RangeOptionValueType[] = [];
  public showOptionCountError: boolean = false;
  public invalidFloatErrorMessage: string[] = [];
  public invalidOptionInputErrorMessage: string = '';
  public invalidSliderErrorMessage: string = '';
  public invalidIndividualInputErrorMessage: string = '';

  public parseFloat(value: any): number {
    return parseFloat(value.toString());
  }

  public mounted() {
    this.isRange = this.criteriaOption.criteria.config ? true : false;
    this.answerValueDetail = this.criteriaOption.optionValues;
    this.options = this.criteriaOption.optionValues;
    this.existingOptions = [...this.criteriaOption.optionValues];

    const indexOfExistingNA = this.answerValueDetail
      .map((optionValue) => optionValue.option)
      .indexOf('N/A');

    const naOptionValue: RangeOptionValueType | undefined = {
      option: 'N/A',
      totalToDate:
        indexOfExistingNA >= 0
          ? this.answerValueDetail[indexOfExistingNA].totalToDate
          : 0,
      value:
        indexOfExistingNA >= 0
          ? this.answerValueDetail[indexOfExistingNA].value
          : 0,
    };
    if (indexOfExistingNA >= 0) {
      this.answerValueDetail.splice(indexOfExistingNA, 1);
    }
    this.answerValueDetail.push(naOptionValue as RangeOptionValueType); // to ensure NA option is always the last item
    this.answerValueDetail.forEach((data: RangeOptionValueType) => {
      this.validateValueError.push({
        option: data.option,
        hasError: false,
      });
    });
    this.options = this.answerValueDetail;

    if (this.editDataCollectionRecord) {
      if (this.mode === 'aggregate') {
        this.sliderValue = this.minValue;
      } else {
        if (this.isRange) {
          const editedRangeValue = this.answerValueDetail.find(
            (data: RangeOptionValueType) => Number(data.value) === 1,
          );
          if (editedRangeValue && editedRangeValue.option === 'N/A') {
            this.hasSelectedNA = true;
            this.sliderValue = this.minValue;
          } else {
            this.sliderValue =
              editedRangeValue && editedRangeValue.option
                ? editedRangeValue.option
                : '';
          }
        } else {
          const editedOptionValue = this.options.find(
            (data: RangeOptionValueType) => Number(data.value) === 1,
          );
          if (editedOptionValue && editedOptionValue.option === 'N/A') {
            this.optionInputIndividual = 'N/A';
            this.setForNaOptionIndividualMode = true;
          } else {
            this.optionInputIndividual =
              editedOptionValue && editedOptionValue.option
                ? editedOptionValue.option
                : '';
          }
        }
      }
    } else {
      if (this.mode === 'aggregate') {
        this.sliderValue = this.minValue;
      }
    }
  }

  public handleRemoveOption(item: any, optionsDataIndex: number) {
    this.removedAnswerValueDetail.push(this.options[optionsDataIndex]);
    this.options.splice(optionsDataIndex, 1);
    this.invalidFloatErrorMessage.splice(optionsDataIndex, 1);

    this.validateValueError.find((element: RangeErrorValidation) => {
      if (element.option === item.option) {
        element.hasError = false;
      }
    });

    this.resultData.criteriaData.forEach(
      (data: DataCollectionCriteriaDataPayload) => {
        if (data.criteria.id === this.criteriaOption.criteria.id) {
          data.optionValues = this.options;
        }
      },
    );
  }

  public handleAddCountValue() {
    if (this.optionInput === '') {
      return;
    }
    const existingInputIndex: number = this.getExistingInputIndex();
    if (existingInputIndex !== -1) {
      this.options[existingInputIndex].value =
        Number(this.options[existingInputIndex].value) +
        Number(this.optionCount);
      this.resetInputParams();
      return;
    }
    this.options.unshift({
      option: this.parseFloat(this.optionInput).toString(),
      totalToDate: this.totalToDateValue,
      value: this.optionCount,
    });
    this.resetInputParams();
  }

  public getExistingInputIndex() {
    return this.options.findIndex((option: any) => {
      return (
        this.parseFloat(option.option) === this.parseFloat(this.optionInput)
      );
    });
  }

  public resetInputParams() {
    this.optionInput = '';
    this.optionCount = 0;
  }

  public getOptionsTotal() {
    let count: number = 0;
    this.options.forEach((option: any) => {
      count = count + Number(option.value);
    });
    return count;
  }

  @Watch('options', { deep: true })
  public watchOptions(newValue: any) {
    this.resultData.criteriaData.forEach((criteriaData: any) => {
      if (criteriaData.criteria.id === this.criteriaOption.criteria.id) {
        criteriaData.optionValues = cloneDeep(this.options);
        criteriaData.optionTotal = this.getOptionsTotal();
      }
    });
  }

  @Watch('setForNaOptionIndividualMode')
  public watchSetForNaOptionIndividualMode(newValue: boolean) {
    if (newValue) {
      this.optionInputIndividual = 'N/A';
      this.setForNaOptionIndividualMode = true;
    } else {
      this.optionInputIndividual = '';
      this.setForNaOptionIndividualMode = false;
    }
    this.handleIndividualInputOption();
  }

  public handleIndividualInputOption() {
    if (this.optionInputIndividual === 'N/A') {
      this.optionInputIndividual = this.optionInputIndividual;
      this.invalidIndividualInputErrorMessage = '';
      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: false,
      });
    } else {
      this.optionInputIndividual = !isNaN(
        this.parseFloat(this.optionInputIndividual),
      )
        ? this.parseFloat(this.optionInputIndividual).toString()
        : this.optionInputIndividual;

      this.invalidIndividualInputErrorMessage = this.optionInputIndividual
        ? !isNaN(this.parseFloat(this.optionInputIndividual))
          ? ''
          : 'Invalid float value'
        : 'Value must not be empty';

      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: isNaN(this.parseFloat(this.optionInputIndividual)),
      });
    }

    if (this.optionInputIndividual === '') {
      this.resultData.criteriaData.forEach((criteriaData: any) => {
        if (criteriaData.criteria.id === this.criteriaOption.criteria.id) {
          criteriaData.optionValues = this.options;
        }
      });
      return;
    }

    const existingOption = this.existingOptions.find((options: any) => {
      return options.option === this.optionInputIndividual;
    });

    if (this.options[this.options.length - 1].option !== 'N/A') {
      this.options.pop();
    }

    this.options.map((item: any) => {
      if (this.optionInputIndividual === item.option) {
        item.value = 1;
      } else {
        item.value = 0;
      }
    });
    if (!existingOption) {
      this.options.push({
        option: this.optionInputIndividual,
        totalToDate: 0,
        value: 1,
      });
    }

    this.resultData.criteriaData.forEach((element: any) => {
      if (element.criteria.id === this.criteriaOption.criteria.id) {
        element.optionValues = this.options;
      }
    });
  }

  get minValue(): number {
    if (this.criteriaOption.criteria.config) {
      return Number(this.criteriaOption.criteria.config.split(',')[0].trim());
    }
    return 1;
  }

  get maxValue(): number {
    if (this.criteriaOption.criteria.config) {
      return Number(this.criteriaOption.criteria.config.split(',')[1].trim());
    }
    return 10;
  }

  public formatSliderTooltip(value: number) {
    return value.toFixed(2);
  }

  get totalToDateRangeValue(): number {
    if (this.sliderValue === '' || !this.parseFloat(this.sliderValue)) {
      this.sliderValue = this.sliderValue;
    } else {
      this.sliderValue = this.parseFloat(this.sliderValue).toString();
    }

    if (this.editDataCollectionRecord && this.criteriaSamplingData) {
      const existingTotalToDateRangeValue = this.existingOptions.find(
        (data: RangeOptionValueType) => {
          if (this.hasSelectedNA) {
            return data.option === 'N/A';
          } else {
            return data.option === this.sliderValue;
          }
        },
      );
      return existingTotalToDateRangeValue
        ? existingTotalToDateRangeValue.totalToDate
        : 0;
    } else {
      const existingOptionValue = this.existingOptions.find(
        (data: RangeOptionValueType) => {
          if (this.hasSelectedNA) {
            return data.option === 'N/A';
          } else {
            return data.option === this.sliderValue;
          }
        },
      );
      const existingTotalToDateRangeValue = this.removedAnswerValueDetail.find(
        (data: RangeOptionValueType) => {
          if (this.hasSelectedNA) {
            return data.option === 'N/A';
          } else {
            return data.option === this.sliderValue;
          }
        },
      );

      return existingOptionValue
        ? existingOptionValue.totalToDate
        : existingTotalToDateRangeValue
        ? existingTotalToDateRangeValue.totalToDate
        : 0;
    }
  }

  get totalToDateValue(): number {
    const optionToCheck =
      this.mode === 'aggregate'
        ? this.parseFloat(this.optionInput)
        : this.parseFloat(this.optionInputIndividual);
    const existingOptionValue = this.existingOptions.find(
      (data: RangeOptionValueType) => {
        if (this.setForNaOptionIndividualMode) {
          return data.option === 'N/A';
        } else {
          return this.parseFloat(data.option) === optionToCheck;
        }
      },
    );
    let existingTotalToDateValue = this.removedAnswerValueDetail.find(
      (data: RangeOptionValueType) => {
        if (this.setForNaOptionIndividualMode) {
          return data.option === 'N/A';
        } else {
          return this.parseFloat(data.option) === optionToCheck;
        }
      },
    );
    if (this.criteriaSamplingData && !existingTotalToDateValue) {
      existingTotalToDateValue = this.criteriaSamplingData.find(
        (data: RangeOptionValueType) => {
          if (this.setForNaOptionIndividualMode) {
            return data.option === 'N/A';
          } else {
            return this.parseFloat(data.option) === optionToCheck;
          }
        },
      );
    }

    return existingOptionValue
      ? existingOptionValue.totalToDate
      : existingTotalToDateValue
      ? existingTotalToDateValue.totalToDate
      : 0;
  }

  public handleAddCountValueRange(value: number) {
    let optionIndex = 0;
    const existingOptionValue = this.criteriaOption.optionValues.find(
      (data: any, index: number) => {
        if (data.option === this.parseFloat(this.sliderValue).toString()) {
          optionIndex = index;
          return data;
        }
      },
    );

    if (existingOptionValue) {
      this.answerValueDetail[optionIndex].value =
        Number(existingOptionValue.value) + Number(value);
    } else {
      this.answerValueDetail.unshift({
        option: this.parseFloat(this.sliderValue).toString(),
        totalToDate: this.totalToDateRangeValue,
        value: Number(value),
      });
    }

    this.countValue = 0;

    this.resultData.criteriaData.forEach((data: any) => {
      if (data.criteria.id === this.criteriaOption.criteria.id) {
        data.optionValues = this.answerValueDetail;
      }
    });
  }

  public validateOptionsDataInputError(index: number): string | null {
    if (
      this.options[index].option === '' ||
      this.options[index].option === '-' ||
      (this.invalidFloatErrorMessage[index] &&
        this.invalidFloatErrorMessage[index].length)
    ) {
      return this.invalidFloatErrorMessage[index] &&
        this.invalidFloatErrorMessage[index].length
        ? this.invalidFloatErrorMessage[index]
        : 'Value must not be empty';
    } else {
      return null;
    }
  }

  public validateOptionsDataInput(index: number) {
    if (this.options[index].option) {
      const optionDataInput: number = this.parseFloat(
        this.options[index].option,
      );

      this.options[index].option = !isNaN(optionDataInput)
        ? optionDataInput
        : '';

      this.invalidFloatErrorMessage[index] = !isNaN(optionDataInput)
        ? ''
        : 'Invalid float value';

      const existingOptionInputIndex: number = this.options.find(
        (option: any, existingIndex: number) => {
          return (
            this.parseFloat(option.option) === optionDataInput &&
            existingIndex !== index
          );
        },
      );
      if (existingOptionInputIndex) {
        this.invalidFloatErrorMessage[index] = 'This Value already exists';
      }

      let existingTotalToDateValue: any = this.removedAnswerValueDetail.find(
        (data: RangeOptionValueType) => {
          if (this.parseFloat(data.option) === optionDataInput) {
            return data;
          }
        },
      );
      if (this.criteriaSamplingData && !existingTotalToDateValue) {
        existingTotalToDateValue = this.criteriaSamplingData.find(
          (data: RangeOptionValueType) => {
            if (this.parseFloat(data.option) === optionDataInput) {
              return data;
            }
          },
        );
      }

      this.options[index].totalToDate = existingTotalToDateValue
        ? existingTotalToDateValue.totalToDate
        : 0;

      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: this.invalidFloatErrorMessage[index].length ? true : false,
      });
    } else {
      this.options[index].totalToDate = 0;
      this.invalidFloatErrorMessage[index] = '';
      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: true,
      });
    }
  }

  public validateOptionsDataValue(index: number) {
    if (!this.options[index].value) {
      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: true,
      });
    } else {
      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: false,
      });
    }
  }

  public validateInput(optionInput: string) {
    this.invalidOptionInputErrorMessage =
      optionInput && isNaN(this.parseFloat(optionInput))
        ? 'Invalid float value'
        : '';

    this.showOptionCountError = isNaN(this.parseFloat(optionInput));
  }

  public updateRangeValue(data: RangeOptionValueType) {
    this.showValueErrorMessage = data.value ? false : true;

    this.validateRangeValue(data.option);

    if (!this.showValueErrorMessage) {
      this.answerValueDetail.find((item: RangeOptionValueType) => {
        if (item.option === data.option) {
          return (item.value = data.value);
        }
      });
      this.resultData.criteriaData.forEach(
        (element: DataCollectionCriteriaDataPayload) => {
          if (element.criteria.id === this.criteriaOption.criteria.id) {
            element.optionValues = this.answerValueDetail;
          }
        },
      );
    }

    this.$emit('updateSubmitButton', {
      index: this.index,
      isError: this.showValueErrorMessage,
    });
  }

  public validateRangeValue(option: number | string) {
    const hasValueValidateError = this.validateValueError.find(
      (element: RangeErrorValidation) => element.option === option,
    );

    if (hasValueValidateError) {
      this.validateValueError.find((element: RangeErrorValidation) => {
        if (element.option === hasValueValidateError.option) {
          element.hasError = this.showValueErrorMessage;
        }
      });
    } else {
      this.validateValueError.push({
        option,
        hasError: this.showValueErrorMessage,
      });
    }

    this.$emit('updateSubmitButton', {
      index: this.index,
      isError: this.showValueErrorMessage,
    });
  }

  public handleRemoveRangeValue(
    item: RangeOptionValueType,
    rangeIndex: number,
  ) {
    this.removedAnswerValueDetail.push(this.answerValueDetail[rangeIndex]);
    this.answerValueDetail.splice(rangeIndex, 1);

    this.validateValueError.find((element: RangeErrorValidation) => {
      if (element.option === item.option) {
        element.hasError = false;
      }
    });

    this.resultData.criteriaData.forEach(
      (data: DataCollectionCriteriaDataPayload) => {
        if (data.criteria.id === this.criteriaOption.criteria.id) {
          data.optionValues = this.answerValueDetail;
        }
      },
    );
  }

  get disableTooltipSlider(): boolean {
    return this.hasSelectedNA ? false : true;
  }

  public showCommentBox(rowData: DataCollectionCriteriaDataPayload) {
    rowData.isCommentSectionExpanded = !rowData.isCommentSectionExpanded;
  }

  public handleMarkedNAValue() {
    this.hasSelectedNA = false;
    this.sliderValue = this.tempSliderValue
      ? this.tempSliderValue
      : this.minValue;
    if (
      this.answerValueDetail[this.answerValueDetail.length - 1].option !== 'N/A'
    ) {
      this.answerValueDetail.pop();
    }
    this.answerValueDetail.map((item: any) => {
      if (item.option === this.minValue.toString()) {
        item.value = 1;
      } else {
        item.value = 0;
      }
    });
    this.resultData.criteriaData.forEach((element: any) => {
      if (element.criteria.id === this.criteriaOption.criteria.id) {
        element.optionValues = this.answerValueDetail;
      }
    });
  }

  public handleUnmarkedNAValue() {
    this.hasSelectedNA = true;
    this.tempSliderValue = this.sliderValue;
    this.sliderValue = this.minValue;
    this.showRangeErrorMessage = false;
    this.invalidSliderErrorMessage = '';
    this.$emit('updateSubmitButton', {
      index: this.index,
      isError: false,
    });

    if (
      this.answerValueDetail[this.answerValueDetail.length - 1].option !== 'N/A'
    ) {
      this.answerValueDetail.pop();
    }
    this.answerValueDetail.map((item: any) => {
      if (item.option === 'N/A') {
        item.value = 1;
      } else {
        item.value = 0;
      }
    });
    this.resultData.criteriaData.forEach((element: any) => {
      if (element.criteria.id === this.criteriaOption.criteria.id) {
        element.optionValues = this.answerValueDetail;
      }
    });
  }

  @Watch('sliderValue', { deep: true })
  @isDifferent
  public watchSliderValue(newValue: any) {
    newValue = newValue ? this.parseFloat(newValue).toString() : newValue;
    if (this.mode === 'aggregate') {
      this.showRangeErrorMessage =
        newValue && isNaN(newValue)
          ? true
          : newValue < this.minValue || newValue > this.maxValue
          ? true
          : false;

      this.invalidSliderErrorMessage =
        newValue && isNaN(newValue) ? 'Invalid float value' : '';

      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: this.showRangeErrorMessage,
      });
    } else {
      if (this.hasSelectedNA && Number(newValue) === this.minValue) {
        return;
      }

      this.hasSelectedNA = false;

      this.showRangeErrorMessage =
        newValue && isNaN(newValue)
          ? true
          : newValue < this.minValue || newValue > this.maxValue
          ? true
          : false;

      this.invalidSliderErrorMessage =
        newValue && isNaN(newValue) ? 'Invalid float value' : '';
      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: this.showRangeErrorMessage,
      });

      if (!this.showValueErrorMessage) {
        const existingRangeValue = this.existingOptions.find(
          (data: any) => data.option === newValue.toString(),
        );
        if (
          this.answerValueDetail[this.answerValueDetail.length - 1].option !==
          'N/A'
        ) {
          this.answerValueDetail.pop();
        }
        this.answerValueDetail.map((item: any) => {
          if (newValue === item.option) {
            item.value = 1;
          } else {
            item.value = 0;
          }
        });
        if (!existingRangeValue) {
          this.answerValueDetail.push({
            option: newValue,
            totalToDate: 0,
            value: 1,
          });
        }

        this.resultData.criteriaData.forEach((element: any) => {
          if (element.criteria.id === this.criteriaOption.criteria.id) {
            element.optionValues = this.answerValueDetail;
          }
        });
      }
    }
  }

  @Watch('countValue')
  public watchCountValue(newValue: number) {
    this.showCountErrorMessage = newValue || newValue === 0 ? false : true;
    if (!this.showRangeErrorMessage) {
      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: this.showCountErrorMessage,
      });
    }
  }

  @Watch('tryToSubmitKey')
  public watchSubmitAction() {
    if (
      (this.isRange && this.sliderValue === '') ||
      (!this.isRange &&
        this.optionInputIndividual === '' &&
        !this.setForNaOptionIndividualMode)
    ) {
      this.showRangeErrorMessage = true;
      if (!this.isRange) {
        this.invalidIndividualInputErrorMessage = 'Value must not be empty';
      }
      this.$emit('updateSubmitButton', {
        index: this.index,
        isError: this.showRangeErrorMessage,
      });
    }
  }
}
</script>
<style lang="scss" module>
.bField .label {
  color: #9f9f9f;
  font-size: 14px;
}
.divider {
  background-color: #dbdbdb;
  height: 1px;
  margin: 1.5rem 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.plusIcon {
  color: #21b5ea;
  width: 16px;
  height: 16px;
}
.plusIconRange {
  color: #21b5ea;
  height: 16px;
  margin-top: 5px;
}
.plusIconColumn {
  padding-left: 20px;
  padding-top: 15px;
}
.disablePlusIcon {
  color: #21b5ea;
  width: 22px;
  height: 22px;
}
.disableOptionPlusIcon {
  color: #21b5ea;
  width: 22px;
  height: 22px;
}
.valueContainer {
  border: 1px solid #dfdfdf;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  // overflow: hidden;
  & > table {
    thead {
      background-color: #ffffff;
      border-bottom: 1px solid #dfdfdf;
      tr {
        font-size: 14px;
        th {
          color: #9f9f9f;
          font-weight: initial !important;
          padding: 13px 12px 13px 18px;
        }
        th:first-child {
          padding-left: 20px;
        }
      }
    }
    tbody {
      background-color: #ffffff;
      tr {
        td {
          color: #444f51;
          border: 0px;
        }
      }
    }
    tfoot {
      td {
        border-width: 1px 0 0;
      }
    }
  }
}
.naValueColumn {
  width: 75% !important;
}
.triggerButton {
  width: 100%;
  justify-content: space-between;
}
.footerCountContainer {
  display: flex;
  flex-direction: row;
}
.countColumnContainer {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px !important;
}
.paddingBottom30 {
  padding-bottom: 30px !important;
}
.paddingBottom15 {
  padding-bottom: 15px !important;
}
.rangeContainer {
  display: flex;
  flex-direction: row;
}
.sliderContainer {
  border: 1px solid rgb(223, 223, 223);
  border-right: unset;
}
.answerChoicesColumn {
  border-right: 1px solid #dfdfdf !important;
  width: 70% !important;
}
.totalToDateColumn {
  padding-top: 18px !important;
  border-right: 1px solid #dfdfdf !important;
  width: 16% !important;
}
.answerChoicesHeader {
  width: 60%;
  border-right: 1px solid #dfdfdf !important;
}
.totalToDateHeader {
  width: 13%;
  text-align: center;
  border-right: 1px solid #dfdfdf !important;
}
.countHeader {
  width: 14%;
  text-align: center;
}
.submitForNACheckboxSpan {
  padding-left: 10px;
  font-size: 14px;
  color: #9f9f9f;
}
.answerChoicesHeaderStyle {
  width: 60% !important;
  border-right: 1px solid #dfdfdf !important;
}
.answerHeaderStyle {
  width: 13% !important;
  text-align: center !important;
  border-right: 1px solid #dfdfdf !important;
}
.answerTotalHeaderStyle {
  width: 13% !important;
  text-align: center !important;
  border-right: 1px solid #dfdfdf !important;
}
.countHeaderStyle {
  width: 14% !important;
  text-align: center !important;
}
.numberInput {
  width: 80px !important;
  height: 44px;
  input {
    background-color: white !important;
    border-color: #dfdfdf !important;
    color: #444f51 !important;
    text-align: right;
    height: 44px;
    padding: 7px 7px;
  }
}
.sliderBodyStyle {
  border-right: 1px solid #dfdfdf !important;
  padding-right: 10px !important;
  height: 100px !important;
}
.rangeValue {
  padding-top: 10px;
  padding-left: 20px;
  color: #b4b3b3;
  font-size: 14px;
}
.validationErrorMessage {
  color: red;
  font-size: 12px;
  margin-top: 4px;
  margin-left: 10px;
}
.validationCountErrorMessage {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}
.bold {
  font-weight: bold;
}
.answerBodyStyle {
  padding: 0px !important;
  height: 0 !important;
}
.rangeScrollableColumn {
  overflow-y: scroll;
  height: 570px;
  overflow-x: hidden;
}
.rangeNonScrollableColumn {
  height: auto;
}
.scrollableColumn {
  overflow-y: scroll;
  height: 450px;
  overflow-x: hidden;
}
.nonScrollableColumn {
  width: 100% !important;
}
.singleNAColumn {
  height: 120px;
}
.answerValueContainer {
  & > table {
    tbody {
      background-color: #ffffff;
      tr {
        td {
          color: #444f51;
          border: 0px;
          padding: 0px;
        }
      }
    }
  }
}
.answerTotalTableStyle {
  width: 28.7% !important;
  border-right: 1px solid #dfdfdf !important;
  text-align: right !important;
  padding-top: 25px !important;
  padding-right: 10px !important;
  padding-bottom: 15px !important;
  color: #9f9f9f !important;
}
.countTableStyle {
  width: 31% !important;
  padding-bottom: 15px !important;
}
.countTableDivStyle {
  font-weight: 300px;
  padding-top: 25px;
  padding-left: 30px;
}
.rangeTable {
  height: 100%;
}
.answerChoicesBottomStyle {
  border-right: 1px solid #dfdfdf !important;
}
.answerTotalBottomStyle {
  border-right: 1px solid #dfdfdf !important;
  border-top: 1px solid #dfdfdf !important;
  text-align: right !important;
  padding-top: 25px !important;
  padding-right: 10px !important;
  color: #9f9f9f !important;
}
.countBottomStyle {
  border-top: 1px solid #dfdfdf !important;
  padding-bottom: 10px !important;
}
.countBottomDivStyle {
  padding-left: 18px;
  padding-top: 20px;
}
.submitAsNAContainer {
  display: flex;
}
.iconsColorUnmarked {
  color: #dfdfdf;
  padding-top: 10px;
}
.iconsColorMarked {
  color: #21b5ea;
  padding-top: 10px;
}
.disableNumberInput {
  width: 80px !important;
  height: 44px;
  input {
    border-color: #dfdfdf !important;
    color: #c9c0c0 !important;
    text-align: right;
    height: 44px;
    padding: 7px 7px;
  }
}
.answerChoicesBodyStyle {
  border-right: 1px solid #dfdfdf !important;
  padding-right: 10px !important;
  height: 100px !important;
  padding-bottom: 50px !important;
}
.answerBodyStyleRange {
  padding-top: 20px !important;
  border-right: 1px solid #dfdfdf !important;
  height: 100px !important;
  color: #b4b3b3 !important;
  text-align: end !important;
}
.totalBodyStyle {
  padding-top: 20px !important;
  height: 100px !important;
  color: #b4b3b3 !important;
  text-align: end !important;
}
.infoTooltip {
  position: absolute !important;
  display: inline-block !important;
}
.infoIcon {
  color: #21b5ea;
  margin-left: 8px !important;
}
.guideSection {
  color: #9f9f9f;
  font-size: 14px;
  margin-top: 8px;
}
</style>
